export default __webpack_public_path__ + "static/media/IMG_4901.099b23f1.jpg";